import { FC, useEffect, useState } from 'react';
import ModalDialog from '../../../../shared/components/modal/ModalDialog';
import { ModalButtonLine } from '../../../../shared/components/modal/ModalButtonLine';
import { LocalContentCheckBox } from './LocalContentCheckBox';
import { LocalContentRadioButtonGroup } from './LocalContentRadioButtonGroup';
import { Button, ButtonSize, ButtonTheme } from '../../../../shared/common/Button';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

const PERMISSION_OPTIONS = [
    { key: 'SELF_CONTENT', value: i18n.t('yourLocalContent.yourTitles.selfContent') },
    { key: 'PERMITTED_CONTENT', value: i18n.t('yourLocalContent.yourTitles.permittedContent') }
];

interface Props {
    show: boolean;
    onAbort: () => void;
    onConfirmLicense: (permission: string) => void;
}

export const LegalConfirmationPopup: FC<Props> = ({ show = false, onAbort, onConfirmLicense }) => {
    const { t } = useTranslation();
    const [confirmed, setConfirmed] = useState(false);
    const [permissionState, setPermissionState] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (!show) {
            setPermissionState(undefined);
            setConfirmed(false);
        }
    }, [show]);

    function onConfirm(checked) {
        setConfirmed(checked);
    }

    function onLegalConfirmationChanged(key) {
        setPermissionState(key);
    }

    function handleOnAbort() {
        setConfirmed(false);
        setPermissionState(undefined);
        onAbort();
    }

    function handleOnConfirmLicense() {
        onConfirmLicense(permissionState ?? '');
    }

    return (
        <ModalDialog
            show={show}
            title="&nbsp;"
            titleClassName="display-none"
            onCloseButtonClick={handleOnAbort}
            wrapClassName="lc-settings-popup"
            preventClosingAction={true}
        >
            <span>{t('yourLocalContent.yourTitles.step1')}</span>
            <h2>{t('yourLocalContent.yourTitles.legalConfirmation')}</h2>
            <p style={{ fontSize: '15px', whiteSpace: 'pre-line' }}>
                {t('yourLocalContent.yourTitles.confirmations.confirmLicense')}
            </p>
            <br />
            <LocalContentRadioButtonGroup
                onRadioChanged={onLegalConfirmationChanged}
                options={PERMISSION_OPTIONS}
                selectedOption={permissionState}
            />
            <br />
            <br />
            <LocalContentCheckBox
                onClick={onConfirm}
                isEnabled={true}
                isChecked={confirmed}
                text={t('yourLocalContent.yourTitles.confirmations.confirmCheckbox')}
            />

            <ModalButtonLine>
                <Button
                    size={ButtonSize.LARGE}
                    theme={ButtonTheme.NEUTRAL}
                    onClick={onAbort}
                    text={t('cancel')}
                    className="bt2 modal-button"
                />

                <Button
                    size={ButtonSize.LARGE}
                    text={t('yourLocalContent.yourTitles.next')}
                    disabled={!confirmed || !permissionState}
                    onClick={handleOnConfirmLicense}
                    className="bt2 modal-button"
                />
            </ModalButtonLine>
        </ModalDialog>
    );
};
